if (!customElements.get('reviews-slider')) {
  customElements.define(
    'reviews-slider',
    class ReviewsSlider extends HTMLElement {
      constructor() {
        super();

        this.sliderInstance = false;
        this.modal = null;
        this.iframe = null;
        this.nativeVideo = null;
        this.handleKeydown = null;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroySlider();

        if (this.handleKeydown) {
          document.removeEventListener(
            'keydown',
            this.handleKeydown
          );

          this.handleKeydown = null;
        }
      }

      init() {
        this.initSlider();
        this.initModal();
      }

      /**
       * Initialize slider using FoxTheme Carousel
       */
      initSlider() {
        const slider = this.querySelector(
          '.reviews-slider__swiper'
        );

        if (!slider) {
          return;
        }

        if (
          !window.FoxTheme ||
          !window.FoxTheme.Carousel
        ) {
          console.error(
            'Reviews Slider: FoxTheme.Carousel is not available.'
          );

          return;
        }

        /*
         * Destroy previous instance.
         */
        this.destroySlider();

        const nextButton = this.querySelector(
          '.reviews-slider__button--next'
        );

        const prevButton = this.querySelector(
          '.reviews-slider__button--prev'
        );

        const paginationEl = this.querySelector(
          '.reviews-slider__pagination'
        );

        const btnGroup = this.querySelector(
          '.reviews-slider__button-group'
        );

        /*
         * Add Swiper classes.
         */
        slider.classList.add('swiper');

        const wrapper = slider.querySelector(
          '.reviews-slider__track'
        );

        if (!wrapper) {
          return;
        }

        wrapper.classList.add(
          'swiper-wrapper'
        );

        /*
         * Initialize FoxTheme Carousel.
         */
        this.sliderInstance =
          new window.FoxTheme.Carousel(
            slider,
            {
              slidesPerView: 1.15,

              spaceBetween: 16,

              speed: 600,

              grabCursor: true,

              watchOverflow: true,

              threshold: 2,

              navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
              },

              pagination: {
                el: paginationEl,
                type: 'fraction',
              },

              breakpoints: {
                750: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },

                1100: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              },
            }
          );

        this.sliderInstance.init();

        /*
         * Скрытие стрелочек, когда все слайды помещаются на экране
         */
        const checkArrows = () => {
          const swiper = this.sliderInstance?.slider;
          if (!swiper || !btnGroup) return;

          if (swiper.isLocked) {
            btnGroup.classList.add('is-locked');
          } else {
            btnGroup.classList.remove('is-locked');
          }
        };

        if (this.sliderInstance.slider) {
          this.sliderInstance.slider.on('resize', checkArrows);
          this.sliderInstance.slider.on('breakpoint', checkArrows);
          this.sliderInstance.slider.on('update', checkArrows);
          setTimeout(checkArrows, 100);
        }
      }

      /**
       * Destroy slider
       */
      destroySlider() {
        if (
          typeof this.sliderInstance !==
          'object'
        ) {
          return;
        }

        if (
          this.sliderInstance.slider &&
          typeof this.sliderInstance.slider.destroy ===
            'function'
        ) {
          this.sliderInstance.slider.destroy(
            true,
            true
          );
        }

        this.sliderInstance = false;
      }

      /**
       * Initialize modal
       */
      initModal() {
        this.modal = this
          .closest(
            '.section-reviews-slider'
          )
          ?.querySelector(
            '[data-reviews-modal]'
          ) || document.querySelector('[data-reviews-modal]');

        if (!this.modal) {
          return;
        }

        this.iframe =
          this.modal.querySelector(
            '[data-video-iframe]'
          );

        this.nativeVideo =
          this.modal.querySelector(
            '[data-native-video]'
          );

        const videos =
          this.querySelectorAll(
            '.reviews-slider__video'
          );

        const closeButtons =
          this.modal.querySelectorAll(
            '[data-modal-close]'
          );

        /*
         * Open video.
         */
        videos.forEach((video) => {
          video.addEventListener(
            'click',
            () => {
              this.openModal(
                video.dataset.videoType,
                video.dataset.videoSrc
              );
            }
          );
        });

        /*
         * Close modal.
         */
        closeButtons.forEach(
          (button) => {
            button.addEventListener(
              'click',
              () => {
                this.closeModal();
              }
            );
          }
        );

        /*
         * ESC.
         */
        this.handleKeydown =
          (event) => {
            if (
              event.key === 'Escape' &&
              this.modal?.classList.contains(
                'is-active'
              )
            ) {
              this.closeModal();
            }
          };

        document.addEventListener(
          'keydown',
          this.handleKeydown
        );
      }

      /**
       * Open modal with video
       */
      openModal(type, src) {
        if (!src || !this.modal) {
          return;
        }

        this.modal.setAttribute(
          'data-video-type',
          type || 'youtube'
        );

        if (type === 'file' && this.nativeVideo) {
          if (this.iframe) {
            this.iframe.style.display = 'none';
            this.iframe.src = '';
          }
          this.nativeVideo.style.display = 'block';
          this.nativeVideo.src = src;
          this.nativeVideo.play().catch(() => {});
        } else if (this.iframe) {
          if (this.nativeVideo) {
            this.nativeVideo.pause();
            this.nativeVideo.style.display = 'none';
            this.nativeVideo.src = '';
          }
          this.iframe.style.display = 'block';
          this.iframe.src = src;
        }

        this.modal.classList.add(
          'is-active'
        );

        this.modal.setAttribute(
          'aria-hidden',
          'false'
        );

        document.documentElement.classList.add(
          'overflow-hidden'
        );
      }

      /**
       * Close modal and stop playback
       */
      closeModal() {
        if (!this.modal) {
          return;
        }

        if (this.iframe) {
          this.iframe.src = '';
        }

        if (this.nativeVideo) {
          this.nativeVideo.pause();
          this.nativeVideo.src = '';
        }

        this.modal.classList.remove(
          'is-active'
        );

        this.modal.setAttribute(
          'aria-hidden',
          'true'
        );

        document.documentElement.classList.remove(
          'overflow-hidden'
        );
      }
    }
  );
}
